// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2716%27 height=%2716%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%236b7280%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3Cpolyline points=%276 9 12 15 18 9%27%3E%3C/polyline%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  border-radius: 8px;
  padding: 2rem;
  max-height: 90vh;
  overflow-y: auto;
  box-sizing: border-box;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  border-bottom: 1px solid #e0e0e0;
  padding-bottom: 1rem;
}

.modal-header h2 {
  margin: 0;
  font-size: 1.5rem;
  color: #333;
}

.close-button {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: background-color 0.2s;
}

.close-button:hover {
  background-color: #f0f0f0;
}

.modal-body {
  margin-bottom: 1.5rem;
}

.form-group {
  margin-bottom: 1.6rem;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-size: 1.4rem;
  font-weight: 500;
  color: #374151;
}

.form-group input,
.form-group select {
  width: 100%;
  padding: 1.2rem;
  border: 1px solid #e5e7eb;
  border-radius: 0.8rem;
  font-size: 1.6rem;
  font-family: inherit;
  color: #2c3948;
  line-height: 1.5;
  transition:
    border-color 0.2s,
    box-shadow 0.2s;
  box-sizing: border-box;
  background: white;
}

.form-group select {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 1.2rem center;
  background-size: 16px 16px;
  padding-right: 3.6rem;
  cursor: pointer;
}

.form-group input:focus,
.form-group select:focus {
  outline: none;
  border-color: #f97316;
}

.form-group input.input-error,
.form-group select.input-error {
  border-color: #dc3545;
}

.error-message {
  color: #dc3545;
  font-size: 0.875rem;
  margin-top: 0.25rem;
  display: block;
}

.required-star {
  color: #ef4444;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  border-top: 1px solid #e0e0e0;
  padding-top: 1rem;
}

.modal-secondary-actions {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 2rem;
  border-top: 1px solid #e0e0e0;
}

.modal-secondary-title {
  display: block;
  margin-bottom: 8px;
  font-size: 1.4rem;
  font-weight: 500;
  color: #374151;
  text-align: left;
}

.modal-secondary-buttons {
  display: flex;
  gap: 0.75rem;
}

.edit-user-login-email-section {
  margin-top: 0.5rem;
}

.edit-user-login-email-divider {
  border: none;
  border-top: 1px solid #e5e7eb;
  margin: 1rem 0;
}

.edit-user-login-email-warning {
  font-size: 1.2rem;
  color: #d97706;
  margin-top: 0.4rem;
}

.modal-body .form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
}
`, "",{"version":3,"sources":["webpack://./src/composants/EditUserModal/EditUserModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;EACrB,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB;;mBAEiB;EACjB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,yDAAiS;EACjS,4BAA4B;EAC5B,wCAAwC;EACxC,0BAA0B;EAC1B,qBAAqB;EACrB,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;AACvB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX","sourcesContent":[".modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.modal-content {\n  background: white;\n  border-radius: 8px;\n  padding: 2rem;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-sizing: border-box;\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1.5rem;\n  border-bottom: 1px solid #e0e0e0;\n  padding-bottom: 1rem;\n}\n\n.modal-header h2 {\n  margin: 0;\n  font-size: 1.5rem;\n  color: #333;\n}\n\n.close-button {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0.5rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  transition: background-color 0.2s;\n}\n\n.close-button:hover {\n  background-color: #f0f0f0;\n}\n\n.modal-body {\n  margin-bottom: 1.5rem;\n}\n\n.form-group {\n  margin-bottom: 1.6rem;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 8px;\n  font-size: 1.4rem;\n  font-weight: 500;\n  color: #374151;\n}\n\n.form-group input,\n.form-group select {\n  width: 100%;\n  padding: 1.2rem;\n  border: 1px solid #e5e7eb;\n  border-radius: 0.8rem;\n  font-size: 1.6rem;\n  font-family: inherit;\n  color: #2c3948;\n  line-height: 1.5;\n  transition:\n    border-color 0.2s,\n    box-shadow 0.2s;\n  box-sizing: border-box;\n  background: white;\n}\n\n.form-group select {\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%236b7280' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 1.2rem center;\n  background-size: 16px 16px;\n  padding-right: 3.6rem;\n  cursor: pointer;\n}\n\n.form-group input:focus,\n.form-group select:focus {\n  outline: none;\n  border-color: #f97316;\n}\n\n.form-group input.input-error,\n.form-group select.input-error {\n  border-color: #dc3545;\n}\n\n.error-message {\n  color: #dc3545;\n  font-size: 0.875rem;\n  margin-top: 0.25rem;\n  display: block;\n}\n\n.required-star {\n  color: #ef4444;\n}\n\n.modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.75rem;\n  border-top: 1px solid #e0e0e0;\n  padding-top: 1rem;\n}\n\n.modal-secondary-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  padding: 2rem;\n  border-top: 1px solid #e0e0e0;\n}\n\n.modal-secondary-title {\n  display: block;\n  margin-bottom: 8px;\n  font-size: 1.4rem;\n  font-weight: 500;\n  color: #374151;\n  text-align: left;\n}\n\n.modal-secondary-buttons {\n  display: flex;\n  gap: 0.75rem;\n}\n\n.edit-user-login-email-section {\n  margin-top: 0.5rem;\n}\n\n.edit-user-login-email-divider {\n  border: none;\n  border-top: 1px solid #e5e7eb;\n  margin: 1rem 0;\n}\n\n.edit-user-login-email-warning {\n  font-size: 1.2rem;\n  color: #d97706;\n  margin-top: 0.4rem;\n}\n\n.modal-body .form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 2rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
